<template>

    <form @submit.prevent="handleSubmit">
        <div class="form-header">
            <h3 class="text-center">Add Arrears</h3>
        </div>
        <div class="form-group">
            <label for="inArrears">Arrears Amount</label>
            <input id="inArrears" ref="inArrearsRef" required type="number" min="0" step="0.01" v-model="arrearsAmount"
                class="form-control text-end" placeholder="Enter arrears amount" />
        </div>
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-6">
                <button class="btn btn-secondary w-100" type="button" @click="emit('close')">Cancel</button>
            </div>
            <div class="col-12 col-lg-6">
                <button class="btn btn-danger w-100" type="submit">Save</button>
            </div>
        </div>
    </form>
</template>

<script setup>
import confirmationService from '@/services/confirmationService';
import { nextTick, onMounted, ref } from 'vue';


//eslint-disable-next-line
const emit = defineEmits(['add-arrears', 'close'])

const arrearsAmount = ref(0);

const handleSubmit = async () => {
    if (!arrearsAmount.value || arrearsAmount.value <= 0)
        return;
    const confirmed = await confirmationService.show("Are you sure you want to proceed?");
    if (!confirmed) return;
    emit('add-arrears', arrearsAmount.value);
}
const resetValues = () => {
    arrearsAmount.value = 0;
}
const inArrearsRef = ref(null);
const focusToInput = ()=>{
     nextTick(() => {
        inArrearsRef.value?.focus();
        inArrearsRef.value?.select();
    })
}
//eslint-disable-next-line
defineExpose({ resetValues,focusToInput })

onMounted(() => {
   focusToInput();
})

</script>

<style scoped></style>